import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["headersContainer", "headerTemplate"]

  addHeader(event) {
    if (!this.hasHeaderTemplateTarget || !this.hasHeadersContainerTarget) {
      return
    }

    const headerTemplateHtml = this.headerTemplateTarget.innerHTML
    var newHeader = document.createElement("div")
    newHeader.innerHTML = headerTemplateHtml
    newHeader = newHeader.firstChild

    this.headersContainerTarget.appendChild(newHeader)
  }

  deleteHeader(event) {
    const headerRow = event.target.closest(".row")

    if (!headerRow) {
      return
    }

    headerRow.remove()
  }
}
